import angular from 'angular';

import EventRepeatDeleteModalComponent from './event-repeat-delete-modal.cmpt';

export default angular
    .module('application.component.modals.component.event-repeat-delete-modal', [])
    .component(EventRepeatDeleteModalComponent.selector, EventRepeatDeleteModalComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/event-repeat-delete-modal/index.js